import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format currency values to K, M format
 * Examples: 1000 → 1K, 1000000 → 1M, 60000 → 60K, 200000 → 200K
 * @param value - The numeric value to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string with K or M suffix
 */
export function formatCurrency(value: number, decimals: number = 1): string {
  if (value === 0) return '0'

  const absValue = Math.abs(value)

  // Format in millions (M)
  if (absValue >= 1000000) {
    return (value / 1000000).toFixed(decimals) + 'M'
  }

  // Format in thousands (K)
  if (absValue >= 1000) {
    return (value / 1000).toFixed(decimals) + 'K'
  }

  // Return as is for values less than 1000
  return value.toString()
}